import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=e5e9c4dc&scoped=true&"
import script from "./resourceList.vue?vue&type=script&lang=js&"
export * from "./resourceList.vue?vue&type=script&lang=js&"
import style0 from "./resourceList.vue?vue&type=style&index=0&id=e5e9c4dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e9c4dc",
  null
  
)

export default component.exports